export const SEEN = 'SEEN';
export const COUNT = 'COUNT';

